import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

var contactMapCard = document.querySelector(".contact-map");
var mapLat = 52.616622
var mapLong = -2.000269

if(contactMapCard){


    setOptions({ 
        //key: "AIzaSyDvQepoA7tAeKo3z06zl4OhAEJVD833X0E" // Key For Localhost
        //key: "AIzaSyApN6gUmfhOoXZS2OLvd_7mW5shl_XLfOI" // Key For Dev Site
        key: "AIzaSyApN6gUmfhOoXZS2OLvd_7mW5shl_XLfOI" // Key For Production Site
    });

    // Get directions modal
    async function initMap() {

        const { Map } = await importLibrary("maps")
        const { AdvancedMarkerElement } = await importLibrary("marker")

        // Set up map
        const map = new Map(document.getElementById("map"), {
            center: { lat: mapLat, lng: mapLong },
            zoom: 11,
            mapId: "google.maps.MapTypeId.ROADMAP",
        })

        // Set up custom marker
        const parser = new DOMParser()
        const pinSvgString = '<svg width="36" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 48"><g><path d="M36,18c0,9.94-16,30-18,30S0,27.94,0,18,8.06,0,18,0s18,8.06,18,18Z" style="fill:#0e49ab"/><circle cx="18" cy="18" r="14" style="fill:#fff"/><g><path d="M22.97,21.07c.4,0,.72-.26.82-.59l.41-1.3h2.57s-.56,1.87-.56,1.87c-.14.46-.33.85-.65,1.22-.67.67-1.59,1.03-2.57,1.02h-3.87c-.69,0-1.35-.33-1.67-.94-.27-.51-.26-1.12-.09-1.68l1.74-5.56c.39-1.24,1.47-2.12,2.75-2.12h4.16c.5-.02.96.16,1.37.43.49.4.73,1.04.55,1.67l-.6,2.15h-2.49s.47-1.54.47-1.54c.08-.25-.06-.48-.31-.53l-2.8.03c-.39,0-.72.27-.83.64l-1.44,4.72c-.08.26.14.52.4.52h2.63Z" style="fill:#feba1c"/><path d="M17.12,13.28c-.49-.25-1.01-.33-1.57-.33h-5.89s-3.17,10.28-3.17,10.28h2.52s.98-3.34.98-3.34h2.29s.78,3.34.78,3.34h2.67s-.93-3.51-.93-3.51c1.04-.19,1.9-.95,2.29-1.95.34-.89.57-1.79.82-2.71.11-.73-.14-1.42-.79-1.78ZM15.21,15.67l-.36,1.2c-.19.63-.7.87-1.3.87h-2.87s.76-2.56.76-2.56l3.34-.02c.15,0,.28.05.35.15.06.08.12.22.07.36Z" style="fill:#0e49ab"/></g></g></svg>';
        const pinSvg = parser.parseFromString(
            pinSvgString,
            "image/svg+xml"
        ).documentElement
        const marker = new AdvancedMarkerElement({
            map,
            position: { lat: mapLat, lng: mapLong },
            content: pinSvg,
        })

        // Set up Street View
        const panorama = new google.maps.StreetViewPanorama(
            document.getElementById("pano"),
            {
                position: { lat: mapLat, lng: mapLong },
                pov: {
                    heading: 34,
                    pitch: 10,
                },
            }
        )

        //map.setStreetView(panorama)

        // Button to show/hide street view
        const streetViewSubmit = document.getElementById("streetViewSubmit")
        const streetViewLabel = streetViewSubmit.querySelector("span")
        const panoElement = document.getElementById("pano")

        streetViewSubmit.addEventListener("click", function () {

            const isActive = streetViewSubmit.classList.toggle("is-active")

            if (isActive) {
                // Activate Street View
                map.setStreetView(panorama)
                panoElement.style.display = "block"
                streetViewLabel.textContent = "Map View"
            } else {
                // Deactivate Street View
                map.setStreetView(null)
                panoElement.style.display = "none"
                streetViewLabel.textContent = "Street View"
            }
        })


        // Add directions
        const directionsService = new google.maps.DirectionsService()
        const directionsRenderer = new google.maps.DirectionsRenderer({
            draggable: true,
            map,
            panel: document.getElementById("panel"),
        })

        const onChangeHandler = function () {
            calculateAndDisplayRoute(directionsService, directionsRenderer)
        }

        const directionsSubmit = document.getElementById("directionsSubmit")
        const directionsClear = document.getElementById("directionsClear")

        directionsSubmit.addEventListener("click", onChangeHandler)

        directionsClear.addEventListener("click", function (e) {
            const directionsSource = document.getElementById("directionsSource")

            // Clear the input
            directionsSource.value = ""

            // Clear the panel
            document.getElementById("panel").innerHTML = ""

            // Reset the Map
            // Clear directions from the map
            directionsRenderer.setDirections({ routes: [] })

            // Optionally reset the map center and zoom if needed
            map.setCenter({ lat: mapLat, lng: mapLong })
            map.setZoom(11)


            // Hide clear button
            directionsClear.classList.add("d-none")
        })

        function calculateAndDisplayRoute(directionsService, directionsRenderer) {
            const start = document.getElementById("directionsSource").value

            directionsService
                .route({
                    origin: start,
                    destination: {
                        lat: mapLat,
                        lng: mapLong,
                    },
                    travelMode: google.maps.TravelMode.DRIVING,
                })
                .then(response => {
                    directionsRenderer.setDirections(response)
                })
                .catch(e => console.log("error loading these directions"))

            directionsClear.classList.remove("d-none")
        }
    }

    initMap()

}